import { render } from "./CommsTable.vue?vue&type=template&id=e62fc58e&scoped=true&lang=pug"
import script from "./CommsTable.vue?vue&type=script&lang=js"
export * from "./CommsTable.vue?vue&type=script&lang=js"

import "./CommsTable.vue?vue&type=style&index=0&id=e62fc58e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e62fc58e"]])

export default __exports__